// extracted by mini-css-extract-plugin
export default {"Article":"Article_Article__jWstO"};